module.exports = __webpack_public_path__ + "static/media/RatingWhite.d7e60f99.svg";